/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Styled components for Settings Profile tab
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.26.0
 * @since 1.3.0
 */

import styled from 'styled-components';

import { CheckBoxContainerStyled } from '@components/common/Checkbox/styled/CheckboxStyled';
import { InputContainerStyled } from '@components/common/Input/styled/InputStyled';
import { LinkContainerStyled } from '@components/common/LinkBlock/styled/LinkStyled';
import { colors, fonts } from '@theme/index';

import { PageSettingsHeaderStyled } from '../../styled/PageSettingsStyled';

export const SettingsProfileColumnStyled = styled.div`
    width: 500px;
`;

export const SettingsProfileComponentContainerStyled = styled.div`
    margin-bottom: 60px;
`;

export const SettingsProfilePreferredLKContainerStyled = styled.div`
    & > div:not(:last-child) {
        margin-bottom: 16px;
    }
`;

export const SettingsProfileControlStyled = styled.div`
    display: flex;
    align-items: center;
    ${LinkContainerStyled} {
        margin-left: 16px;
    }
    margin-bottom: 60px;
`;

export const SettingsProfileContactsParamContainerStyled = styled.div`
    & ${CheckBoxContainerStyled} {
        margin-top: 12px;
        margin-left: 6px;
    }

    &:not(:last-child) {
        margin-bottom: 24px;
    }
`;

export const SettingsProfileHintsContainerStyled = styled.div`
    & ${PageSettingsHeaderStyled} {
        margin-bottom: 12px;
    }
    & ${CheckBoxContainerStyled} {
        margin-left: 6px;
        margin-bottom: 12px;
    }
`;

export const SettingsProfileQuestionSelectStyled = styled.div`
    margin-bottom: 16px;
    .select__select-item,
    .select-container {
        ${fonts.textMain};
    }
    .select__select-item {
        height: 40px;
    }
    .select__select-list {
        max-width: 600px;
    }
`;

export const SettingsProfileLabelStyled = styled.div`
    ${fonts.textMain};
    margin-bottom: 4px;
`;

export const SettingsProfilePopupContainerStyled = styled.form`
    width: 590px;
    & .loader__frame {
        transform: translate(-50%, -50%);
    }

    ${InputContainerStyled}:not(:last-child) {
        margin-bottom: 16px;
    }
`;

export const SettingsProfilePopupTitleStyled = styled.div`
    padding: 24px;
    ${fonts.textHeader3};
    margin-bottom: 0;
`;

export const SettingsProfilePopupContentStyled = styled.div`
    padding: 16px 24px;
`;

export const SettingsProfilePopupControlStyled = styled.div`
    padding: 24px;
`;

export const SettingsProfileQuestionCurrentQuestionStyled = styled.div`
    padding: 0 20px;
    height: 48px;
    line-height: 48px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow-x: hidden;
    color: ${colors.textColorOpacity};
    background-color: ${colors.backgroundColorDisabled};
`;

export const SettingsProfileQuestionCurrentContainerStyled = styled.div`
    margin-bottom: 16px;

    ${LinkContainerStyled} {
        display: inline-block;
        margin-top: 8px;
    }
`;

export const SettingsProfilePasswordContainerStyled = styled.div`
    & ${InputContainerStyled}:not(:last-child) {
        margin-bottom: 24px;
    }
`;
